import { render, staticRenderFns } from "./EmployeeAnnouncement.vue?vue&type=template&id=1a2d91fd"
import script from "./EmployeeAnnouncement.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports